module.exports = __webpack_public_path__ + "static/media/akademik.a87186c3.png";